module.exports = __webpack_public_path__ + "static/media/ico-trash.de96a41e.svg";